//
import WhProduct from '@/models/Warehouse/WhProduct'
//

export default class WhProductAdjustStock extends WhProduct {
    
    //
    wh_repacking_products = []
    branch_office_selected = []

    //
    static appends = [
        'branch_offices',
        //'last_provider_code',
        //'repacking_children',
        'sale_prices',
        'stocks',
        'critical_stock_branch_office_of_warehouse',
        'stock_branch_office_of_warehouse',
        
    ]

    //
    static includes = ['wh_item','wh_product_global_stocks', 
        'wh_product_reservations',]

    get reservated() {
        return this.getProperty('wh_product_reservations', []).reduce((e, c) => c.reservated, 0)
    }

    get stockWarehouse() {
        if(this.wh_product_global_stocks.length>0){
            return this.wh_product_global_stocks[0].stock
        }
        else{
            return 0
        }
    }

}
